//@TODO This file can/should be removed once we're done moving to new fnapi client code
export function getQueryString(queryToFind) {
	// LOGGLY: log the user guid and the window.location
	if (window.location.hash.indexOf(queryToFind) > 1) {
		return (window.location.hash.substring(window.location.hash.indexOf(queryToFind) + queryToFind.length, window.location.hash.indexOf(queryToFind) + window.location.hash.length));
	}
	else {
		return(null)
	}
}



// WEBPACK FOOTER //
// ./src/js/utilities/get-query-string.jsx